import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ProductData } from '../ProductData/Product'
import { IncreaseQuantity,DecreaseQuantity } from "../../redux/action/action";
import { CartButon } from '../CartButton/CartButon';

export const Cart = () => {
    const carItem = useSelector(state=>state.productList.Carts)
    const totalItem = useSelector(state=>state.productList.numberCart)
    console.log(carItem)

  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4"
                >
                    <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
                    >
                       {carItem?.map(product=>{ 
                        return (
                            <div className="flex justify-between border-b-2 mb-2" key={product.id}>
                            <div className="text-lg py-2">
                                <p>{product.name}</p>
                            </div>
                            <div className="text-lg py-2">
                               <CartButon quantity={product.quantity} id={product.id}
                                stock={product.stock}
                               />
                            </div>
                        </div>
                        )
                       })}

                        <div
                            className="flex justify-center items-center text-center"
                        >
                            <div className="text-xl font-semibold">
                                <p>Total Item</p>
                                <p className="text-5xl">
                                {totalItem}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
                    >
                        <div
                            className="flex justify-center items-center text-center"
                        >
                            <div className="text-xl font-semibold">
                                <p>Total Price</p>
                                <p className="text-5xl">
                                {
                                carItem.reduce((ac,cc)=>{
                                    let totalItem =cc.quantity*cc.price
                                    return ac + totalItem
                                },0)
                                }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
  )
}
